<template>
  <div class="print-setting">
    <div class="wrap-content">
      <div class="fixed-display">
        <div class="setting-title">印刷設定</div>
        <div class="setting-tab-title-bar">
          <div v-for="tab in tabs" :key="tab.link">
            <base-setting-tab-title
              :title="tab.title"
              :link="tab.link"
              :names="tab.names"
            />
          </div>
        </div>
      </div>
      <div class="content-body">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import BaseSettingTabTitle from '@/components/parts/atoms/BaseSettingTabTitle.vue'

export default {
  name: 'PrintSetting',

  components: {
    BaseSettingTabTitle
  },

  data() {
    return {
      tabs: [
        {
          title: '書類',
          link: 'print-setting-general',
          names: ['print-setting-general']
        },
        {
          title: '宛名シート',
          link: 'print-setting-address-sheet',
          names: ['print-setting-address-sheet']
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.print-setting {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  text-align: left;
  > .wrap-content {
    > .fixed-display {
      position: sticky;
      position: -webkit-sticky;
      top: 24px;
      transform: translateY(-24px);
      padding-top: 24px;
      margin-bottom: -24px;
      z-index: 100;
      background-color: #{$white};
      > .setting-title {
        font-size: 20px;
        font-weight: bold;
      }
      > .setting-tab-title-bar {
        display: flex;
        flex-direction: row;
        height: 26px;
        margin-top: 20px;
        padding-bottom: -4px;
        border-bottom: 1px solid;
        border-color: #{$light-grey};
        box-sizing: border-box;
      }
    }
    > .content-body {
      min-width: 614px;
    }
  }
}
</style>
